<template>
  <!--添加编辑商品-->
  <div>
    <!--<van-notice-bar :text="$t('shop.Add_item')"/>-->
    <van-form @submit="onSubmit">
      <van-cell :title="$t('shop.product')" is-link  :value="shop_product_type_name" title-style="text-align:left;" @click="productType"/>
      <van-field
        v-model="shop_name"
        v-show="shop_name_custom != 2"
        :name="$t('shop.Trade_name')"
        :label="$t('shop.Trade_name')"
        :placeholder="$t('shop.Trade_name')"
        :rules="[{ message: $t('shop.Please_fill_product_name') }]"
        :disabled="shop_name_custom === 0 ? true : false"
        input-align="right"
      />
      <van-field
        v-model="appoint_uid"
        v-show="type === 4 || type === 5"
        :name="$t('shop.designated_user_id')"
        :label="$t('shop.designated_user_id')"
        :placeholder="$t('shop.designated_user_placeholder')"
        id = "designated"
        input-align="right"
      />
      <van-field
        v-model="shop_price"
        type="number"
        v-show="shop_price_custom != 2"
        :disabled="shop_price_custom === 0 ? true : false"
        :name="$t('shop.commodity_price')"
        :label="$t('shop.commodity_price')"
        :placeholder="$t('shop.commodity_price')"
        input-align="right"
      />

      <van-field
        v-model="shop_url"
        v-show="shop_url_custom != 2"
        :disabled="shop_url_custom === 0 ? true : false"
        :name="$t('shop.Product_links')"
        :label="shop_url_fixed ? shop_url_fixed : $t('shop.Product_links')"
        :placeholder="link_placeholder ? link_placeholder : $t('shop.Product_external_links')"
        :rules="[{ message: $t('shop.Please_fill_product_external_link') }]"
        input-align="left"
      >
      </van-field>

      <van-field name="shop_logo" v-show="shop_logo_custom != 2" :label="$t('shop.Product_picture')">
        <template #input>
          <van-col span="24" class="my_information" style="margin-top: 2em;margin-left: -5em;">
            <van-image  width="7em" height="7em" :src="shop_logo_url" fit="cover" v-if="shop_logo_custom === 0 && shop_logo_url"/>
            <img src="../assets/img/shop_img.png" class="shop2" v-else-if="shop_logo_custom === 0 && !shop_logo_url">
            <van-image width="7em" height="7em" :src="shop_logo_url" fit="cover" v-else-if="shop_logo_url" @click="img_upload('img')"/>
            <img src="../assets/img/shop_img.png" class="shop2" @click="img_upload('img')" v-else>
          </van-col>
        </template>
      </van-field>

      <div>
        <van-button class="add_shop_button" type="primary" round block native-type="submit" v-if="id">{{ $t('shop.Edit_item') }}</van-button>
        <van-button class="add_shop_button" type="primary" round block native-type="submit" v-else>{{ $t('shop.Add_item') }}</van-button>
      </div>

      <!--<div style="margin: 16px;">
        <van-button type="primary" round block native-type="submit">{{ $t('shop.Add_item') }}</van-button>
      </div>-->
    </van-form>

    <van-popup v-model:show="productTypeShow" position="bottom">
      <van-picker
        show-toolbar
        :default-index="productTypeIndex"
        :columns="productTypeList"
        @confirm="onConfirm"
        @cancel="productTypeShow = false"
        :confirm-button-text="$t('btn.submit')"
        :cancel-button-text="$t('btn.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
    import axios from "axios";
    import { Toast, Uploader } from 'vant'
    import { judgeIosAndroid } from '@/assets/js/models.js'
    let Base64 = require('js-base64').Base64
    export default {
        name: "shop_add",
        data() {
            return {
                shop_name_disabled: true,
                productTypeShow: false,
                productTypeList:[],
                productTypeIndex: 0,
                id:0,
                appoint_uid: '',
                shop_price: '',
                shop_name: '',
                shop_url: '',
                shop_logo_url: '',
                shop_name_custom: 1,
                shop_price_custom: 0,
                shop_logo_custom: 0,
                shop_url_custom: 0,
                shop_url_fixed: '',
                type: 1,
                shop_product_type_name: '',
                shop_product_type: 0,
                link_placeholder: ''
            }
        },
        created: function () {
            document.title = this.$route.query.id>0?this.$t('shop.Edit_item_title'):this.$t('shop.Add_item_title');
            this.getProductTypeList()

        },
        components: {
          [Uploader.name]: Uploader
        },
        mounted() {
          // 将要给原生调用的方法挂载到 window 上面
          window.getValueFromApp = this.getValueFromApp
        },
        methods: {
          getProductTypeList() {
            const uid = this.$route.query.uid
            const token = this.$route.query.token
            axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/product_type_list",{ params:{ uid:uid,token:token }}).then(res => {
              console.log(res.data);
              if (res.data.code == 1) {
                this.productTypeList = res.data.data
                const value = this.productTypeList[0]
                this.convert(value)
              }
            })
          },
          onConfirm(value, index) {
            console.log(value)
            console.log(index)
            this.shop_product_type_name = value.text
            this.shop_product_type = value.id
            this.shop_name_custom = value.product_name_custom
            this.shop_price_custom = value.price_custom
            this.shop_logo_custom = value.cover_picture_custom
            this.shop_url_custom = value.link_custom
            this.shop_url_fixed = value.link_fixed
            this.shop_logo_url = value.cover_picture
            this.shop_price = value.price > 0 ? value.price : ''
            this.shop_name = value.product_name
            this.shop_url = value.link
            this.type = value.type
            this.appoint_uid = ''
            this.link_placeholder = value.link_placeholder
            this.productTypeShow = false
          },
          productType() {
            for(let i=0; i< this.productTypeList.length; i++) {
              if(this.productTypeList[i]['id'] === this.shop_product_type ) {
                this.productTypeIndex = i
              }
            }
            this.productTypeShow = true
          },
          convert(value) {
            const uid = this.$route.query.uid
            const token = this.$route.query.token
            const id = this.$route.query.id
            axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/get_goods",{ params:{ uid:uid,token:token,id:id}}).then(res => {
              console.log(res.data);
              if (res.data.code == 1) {

                this.id = res.data.data && res.data.data.id != undefined ? res.data.data.id : '0'
                this.status = res.data.data && res.data.data.status != undefined ? res.data.data.status : '-1'
                this.shop_name = res.data.data && res.data.data.shop_name != undefined ? res.data.data.shop_name : value.product_name
                this.shop_price = res.data.data && res.data.data.shop_price > 0 ? res.data.data.shop_price : value.price > 0 ? value.price : ''
                this. shop_url = res.data.data ? res.data.data. shop_url : value.link
                this.shop_logo_url = res.data.data && res.data.data.shop_logo != undefined ? res.data.data.shop_logo : value.cover_picture
                this.type = res.data.data && res.data.data.type != undefined ? res.data.data.type : value.type

                this.shop_product_type =  res.data.data && res.data.data.shop_product_type != undefined ? res.data.data.shop_product_type : value.id
                this.shop_name_custom = res.data.data && res.data.data.shop_name_custom != undefined ? res.data.data.shop_name_custom : value.product_name_custom
                this.shop_price_custom = res.data.data && res.data.data.shop_price_custom != undefined ? res.data.data.shop_price_custom : value.price_custom
                this.shop_logo_custom = res.data.data && res.data.data.shop_logo_custom != undefined ? res.data.data.shop_logo_custom : value.cover_picture_custom
                this.shop_url_custom = res.data.data && res.data.data.shop_url_custom != undefined ? res.data.data.shop_url_custom : value.link_custom
                this.shop_url_fixed = res.data.data && res.data.data.shop_url_fixed != undefined ? res.data.data.shop_url_fixed : value.link_fixed
                this.link_placeholder = res.data.data && res.data.data.link_placeholder != undefined ? res.data.data.link_placeholder : value.link_placeholder
                this.appoint_uid = res.data.data && res.data.data.appoint_uid != undefined ? res.data.data.appoint_uid : ''
                this.shop_product_type_name = value.text

                for(let i=0; i< this.productTypeList.length; i++) {
                  if(this.productTypeList[i]['id'] === this.shop_product_type ) {

                    this.productTypeIndex = i
                    this.shop_product_type_name = this.productTypeList[i].text
                    this.type = this.productTypeList[i].type
                  }
                }
              }
            })
          },
          img_upload (name) {
            // 上传头像
            this.mobile_intercept(name)
          },
          mobile_intercept(name) {
            //  拦截
            const isIos = judgeIosAndroid();
            if (isIos == true) {
              // ios传值方法postMessage（val）传值方式
              window.webkit.messageHandlers.upload_avatar.postMessage(name)
            } else {
              // 安卓传值方法goSubmitted（val）传值方式
              window.AndroidJs.upload_avatar(name)
            }
          },
          getValueFromApp(name,url) {
            // 上传回调
            // 下载完成回调(ios和android调用接口)
            this.shop_logo_url = url
          },
          onSubmit() {
              if(this.shop_product_type === undefined || this.shop_product_type <= 0){
                Toast(this.$t('shop.Please_product'))
                return false
              }
              const token = this.$route.query.token;
              const uid = this.$route.query.uid;
              const shop_url = this.type === 1 ? Base64.encode(this.shop_url) : this.shop_url
            console.log(this.type)
              let params = {
                  params: {
                      uid: uid,
                      token: token,
                      id:this.id,
                      shop_logo_url: this.shop_logo_url,
                      shop_name: this.shop_name,
                      shop_price: this.shop_price,
                      shop_url: shop_url,
                      shop_product_type: this.shop_product_type,
                      appoint_uid : this.appoint_uid
                  }
              };
              axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/add_shop_product", params).then(res => {
                  console.log(res.data);
                  Toast(res.data.msg);
                  if (res.data.code === 1) {
                    const _this = this
                    setTimeout(() =>{
                        const uid = _this.$route.query.uid;
                        const token = _this.$route.query.token;
                        _this.$router.push({path:'/shopList', query: {uid: uid, token: token}});
                    },3000)
                  }
              });
          }
        }
    }
</script>

<style scoped>
#designated::-webkit-input-placeholder{font-size: 10px;}    /* 使用webkit内核的浏览器 */
#designated:-moz-placeholder{font-size: 10px;}                  /* Firefox版本4-18 */
#designated::-moz-placeholder{font-size: 10px;}                  /* Firefox版本19+ */
#designated:-ms-input-placeholder{font-size: 10px;}           /* IE浏览器 */
</style>



// WEBPACK FOOTER //
// src/components/shop_add.vue